import client from "../../../api/client";

export default async function getFavouriteRoomListings() {
    const response = await client.get("/room-listings/favourites/rooms");
    return response?.data || {};
}